// src/providers/providers.tsx
'use client'

import { InactiveUserGuard } from '@/components/shared'
import { AuthProvider } from '@/contexts/AuthContext'
import { SidebarProvider } from '@/contexts/SidebarContext'
import type React from 'react'
import { QueryProvider } from './query-client'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryProvider>
      <AuthProvider>
        <SidebarProvider>
          <InactiveUserGuard>{children}</InactiveUserGuard>
        </SidebarProvider>
      </AuthProvider>
    </QueryProvider>
  )
}
